import { motion } from "framer-motion";
import { Gift, Radio, Users, Ticket } from "lucide-react";
import { FaDiscord } from "react-icons/fa6";
import { SiKick } from "react-icons/si";
import { EASE, KICK_URL } from "@/lib/site";
import { RevealLine } from "./RevealLine";

const Cell = ({ className = "", delay = 0, children, testId }) => (
  <motion.div
    initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={`bento-cell ${className}`} data-testid={testId}
  >
    {children}
  </motion.div>
);

export const Bento = () => (
  <section id="stream" className="px-5 py-24 sm:px-8 lg:px-12 lg:py-36" data-testid="stream-section">
    <div className="mx-auto max-w-7xl">
      <p className="eyebrow">On stream</p>
      <h2 className="section-title mt-4 font-display text-white">
        <RevealLine>Almost every day.</RevealLine>
        <RevealLine delay={0.1} className="text-white/85">Always with the chat.</RevealLine>
      </h2>

      <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-6 md:grid-rows-[auto_auto]">
        <Cell className="photo-cell md:col-span-3 md:row-span-2 min-h-[420px]" testId="bento-photo">
          <img src="/assets/dafaber-profile.png" alt="Dafaber" className="absolute inset-0 h-full w-full object-cover object-top" />
          <div className="photo-shade" />
          <div className="relative mt-auto">
            <span className="live-pill"><span className="live-dot" /> Live almost daily</span>
            <p className="mt-4 max-w-sm font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl">Slots, bonus buys and big hunts — straight from Roobet.</p>
            <a href={KICK_URL} target="_blank" rel="noopener noreferrer" className="kick-btn mt-6" data-testid="bento-watch-kick-button">
              <SiKick className="h-4 w-4" /> Watch on Kick
            </a>
          </div>
        </Cell>

        <Cell className="md:col-span-3 gold-cell" delay={0.1} testId="bento-giveaways">
          <Gift className="h-8 w-8" />
          <p className="mt-auto pt-10 font-display text-3xl font-extrabold leading-tight sm:text-4xl">Regular giveaways.</p>
          <p className="mt-3 max-w-md text-[15px] font-medium text-[#1d2550]">Cash drops, bonus buys and surprise giveaways on stream and in Discord. Be there, be active, get lucky.</p>
        </Cell>

        <Cell className="md:col-span-2" delay={0.15} testId="bento-live">
          <Radio className="h-7 w-7 text-[#FFC700]" />
          <p className="mt-auto pt-8 font-display text-2xl font-extrabold text-white">Live on Kick</p>
          <p className="mt-2 text-sm text-white/85">Almost daily streams on Kick. Turn notifications on.</p>
        </Cell>

        <Cell className="md:col-span-1 code-cell" delay={0.2} testId="bento-code">
          <Ticket className="h-7 w-7 text-[#FFC700]" />
          <p className="mt-auto pt-8 text-xs uppercase tracking-[0.2em] text-white/80">Code</p>
          <p className="font-mono text-lg font-bold text-white">DAFABER</p>
        </Cell>

        <Cell className="md:col-span-6 discord-cell" delay={0.1} testId="bento-discord">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-4">
              <FaDiscord className="h-10 w-10 text-white" />
              <div>
                <p className="font-display text-2xl font-extrabold text-white">Join the community</p>
                <p className="flex items-center gap-2 text-sm text-white/90"><Users className="h-4 w-4" /> Giveaways, big wins and stream alerts</p>
              </div>
            </div>
            <a href="https://discord.gg/fwSDeNYSGB" target="_blank" rel="noopener noreferrer" className="discord-btn" data-testid="bento-join-discord-button">Join the Discord</a>
          </div>
        </Cell>
      </div>
    </div>
  </section>
);
